import { BreadcrumbsService } from './breadcrumbs.service';
import { Component, OnInit } from '@angular/core';
import { ONBOARD_CONSTANTS } from '../../app.constants';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';
import { TravellersService } from '../travelers/travellers.service';
import { ErrorService } from '../error/error.service'
import { BuywifiService } from '../../services/buywifi.service';
import { AppService } from '../../app.service';
import { LandingComponent } from '../landing/landing.component';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html'
})
export class BreadcrumbsComponent implements OnInit {
  private subscription: Subscription;
  breadCrumbs: any;
  private activeState: Array<string> = [];
  public currentState;
  public deviceToken;
  breadCrumbActive = {};
  constructor(private breadcrumbsService: BreadcrumbsService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private travellersService: TravellersService,
    private errorService: ErrorService,
    private buywifiService: BuywifiService, private appService: AppService
  ) { }

  ngOnInit() {
    this.checkIfDataIsPresent();
    this.breadCrumbs = [
      { label: 'wifiHeader.wifiKeys', id: 'wifiKeys', 'active': true, current: true },
      { label: 'wifiHeader.payment', id: 'payment', 'active': false, current: false },
      { label: 'wifiHeader.confirmation', id: 'confirmation', 'active': false, current: false }];
    this.currentState = this.buywifiService.getCurrentState();
    
    switch (this.router.url) {
      case '/buywifi/product':
        this.activeState = ['0'];
        this.currentState = 0;
        break;
      case '/buywifi/payment':
        this.activeState = ['0', '1'];
        this.currentState = 1;
        break;
      case '/buywifi/confirmation':
        this.activeState = ['2'];
        this.currentState = 2;
        break;
      default:
        this.activeState = ['0'];
        break;
    }
    this.updateActiveState(this.activeState);
    this.buywifiService.hideHeaderFooter();
    if (!ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
      this.deviceToken = '/home?deviceToken=' + sessionStorage.getItem('deviceToken');
    } else {
      this.deviceToken = '/home';
    }
  }

  checkIfDataIsPresent() {
    if (this.router.url.toString().search('/buywifi') === 0 && !((this.travellersService.getPassengerDetails() &&
    this.travellersService.getPassengerDetails() !== undefined) || (this.travellersService.getCharterPassengerDetails() &&
    this.travellersService.getCharterPassengerDetails() !== undefined) || this.travellersService.passengerResponseReceived)) {
      this.appService.redirectToHomePage();
    }
  }

  updateActiveState(activeState) {
    for (const i in this.breadCrumbs) {
      if (activeState.indexOf(i) === -1) {
        this.breadCrumbs[i].active = false;
      } else {
        this.breadCrumbs[i].active = true;
      }
    }
  }

  goToBreadcrumb(state) {
    switch (state) {
      case 1: {
        this.router.navigate(['buywifi/product']);
        break;
      }
      case 2: {
        this.router.navigate(['buywifi/payment']);
        break;
      }
      default: {
        if (!ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
          this.router.navigate(['/home'], { queryParams: { 'deviceToken': sessionStorage.getItem('deviceToken') } });
        } else {
          this.router.navigate(['/home']);
        }
        LandingComponent.showActivateScreen = false;
        this.travellersService.clearPassengerDetails();
        this.buywifiService.setChatBotShow();
        this.errorService.removeError();
        break;
      }
    }
  }

}
